import { render } from "./MyStoreMenu.vue?vue&type=template&id=47e8fc50&scoped=true"
import script from "./MyStoreMenu.vue?vue&type=script&lang=ts"
export * from "./MyStoreMenu.vue?vue&type=script&lang=ts"

import "./MyStoreMenu.vue?vue&type=style&index=0&id=47e8fc50&lang=scss&scoped=true"
import "./MyStoreMenu.vue?vue&type=style&index=1&id=47e8fc50&lang=scss"
script.render = render
script.__scopeId = "data-v-47e8fc50"

export default script